import { useTranslation } from 'react-i18next';

import MarkAllAsReadButton from './MarkAllAsReadButton';

interface NotificationsHeaderProps {
  onMarkAllAsRead: () => void;
}

const NotificationsHeader = ({ onMarkAllAsRead }: NotificationsHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between p-4 items-center">
      <span className="text-size-sm font-medium text-black">{t('notifications_label')}</span>
      <MarkAllAsReadButton onClick={onMarkAllAsRead} />
    </div>
  );
};

export default NotificationsHeader;
